import { ReactElement, useState, useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { Box, Carousel, useBelowBreakpoint, type CarouselProps } from '@stitch-fix/mode-react';
import { useInView } from 'react-intersection-observer';
import { ProgressIndicator } from './ProgressIndicator';
import styles from './styles.module.scss';
type Slide = {
  durationMs?: number;
  ui: ReactElement;
};
const DesktopCarousel = ({
  slides,
  slideWidth
}: {
  slides: ReactElement[];
  slideWidth: CarouselProps['slideWidth'];
}) => <Box maxWidth="1084px" data-testid="desktop-carousel">
    <Carousel ariaLabel="Carousel" slideWidth={slideWidth}>
      {slides}
    </Carousel>
  </Box>;
const MobileCarousel = ({
  slides
}: {
  slides: Slide[];
}) => {
  const [ref, inView] = useInView();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: 'start',
    watchFocus: false
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    if (!emblaApi) {
      return undefined;
    }
    const onSelect = () => {
      setCurrentSlide(emblaApi.selectedScrollSnap());
    };
    emblaApi.on('select', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi]);
  const nextSlide = useCallback(() => {
    if (!emblaApi) return;
    if (emblaApi.canScrollNext()) {
      emblaApi.scrollNext();
    }
  }, [emblaApi]);
  return <Box maxWidth="644px" data-testid="mobile-carousel" ref={ref} className={styles.mobileCarousel}>
      <ProgressIndicator currentSlide={currentSlide} slideCount={slides.length} nextSlide={nextSlide} durationMs={slides[currentSlide].durationMs} isInView={inView} />
      <div ref={emblaRef} style={{
      overflow: 'hidden'
    }}>
        <div style={{
        display: 'flex'
      }}>
          {slides.map(slide => <div className={styles.slideContent} style={{
          flex: '0 0 100%'
        }} key={slide.ui.key}>
              {slide.ui}
            </div>)}
        </div>
      </div>
    </Box>;
};
export const CarouselWithInstaStories = ({
  slides,
  slideWidth
}: {
  slides: Slide[];
  slideWidth: CarouselProps['slideWidth'];
}) => {
  return useBelowBreakpoint(900) ? <MobileCarousel slides={slides} /> : <DesktopCarousel slides={slides.map(slide => slide.ui)} slideWidth={slideWidth} />;
};